import { isAddToCartPayload } from '../../../../shoppable/types';
import { InternalEvent } from '../../../enums';
import {
  InternalAddToCartPayload,
  InternalEventPayloadValidator,
} from '../../../types';

export const internalAddToCartPayloadValidator: InternalEventPayloadValidator<
  InternalEvent.ADD_TO_CART
> = (payload: unknown): payload is InternalAddToCartPayload =>
  isAddToCartPayload(payload);
